<template>
  <div class="vx-row" id="pages">
    <div class="vx-col w-full">
      <vx-card>
        <form>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                class="inputx"
                v-model="model.title"
                name="categoryTitle"
                :label="$t('Title')"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('categoryTitle')"
                >{{ errors.first("categoryTitle") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <label class="vs-select--label">{{ $t("ParentCategory") }}</label>
              <v-select
                label="title"
                name="parentCategory"
                :options="postCategories"
                v-model="model.parent"
                :reduce="x => x.id"
                dir="rtl"
              >
              </v-select>
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <b>{{ $t("Description") }}</b>

              <quill-editor
                v-model="model.description"
                :options="editorDescription"
                :label="$t('Description')"
                height="250"
              >
              </quill-editor>
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                class="inputx"
                v-model="model.priority"
                name="categoryPriority"
                v-validate="{ regex: '^([0-9]+)$' }"
                :label="$t('Priority')"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('categoryPriority')"
                >{{ errors.first("categoryPriority") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-checkbox v-model="model.isLeaf">{{
                $t("IsLeaf")
              }}</vs-checkbox>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button
                class="mb-2 submit-btn bg_l_green float-right mr-4"
                @click.prevent="submitForm"
                >{{ $t("Submit") }}</vs-button
              >
              <router-link
                :to="{ path: '/weblog/PostCategory/Index' }"
                class="vs-component vs-button back-btn"
                color="rgb(62, 201, 214)"
                type="filled"
              >
                {{ $t("BackToList") }}
              </router-link>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import { mapGetters, mapActions } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
const dict = {
  custom: {
    categoryTitle: {
      required: "لطفا عنوان را وارد نمایید."
    },
    categoryPriority: {
      regex: "تنها مجاز به وارد کردن مقادیر عددی می‌باشید."
    }
  }
};
Validator.localize("fa", dict);

export default {
  name: "Content_management_PostCategory_Create",
  data() {
    return {
      model: {
        title: "",
        priority: null,
        description: "",
        parent: null,
        isLeaf: true
      },
      editorDescription: {
        placeholder: ""
      }
    };
  },
  components: {
    "v-select": vSelect,
    quillEditor
  },
  computed: {
    ...mapGetters({
      postCategories: "postcategory/list"
    })
  },
  mounted() {
    this.fetchPostCategories();
  },
  methods: {
    ...mapActions({
      fetchPostCategories: "postcategory/fetch",
      createPostCategory: "postcategory/create"
    }),
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createPostCategory(this.model)
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000
              });
            })
            .then(() => this.$router.push("PostCategory/Index"));
        }
      });
    }
  }
};
</script>
